import sharedLabel from '../../../translation'
import type {ILabel} from '../../../../../types'

export default {
    ...sharedLabel,    
    selectHint: <ILabel>{
        de: 'Dieser Artikel ist in verschiedenen Varianten verfügbar. Bitte wählen Sie aus:',
        en: 'This item is available in different variations. Please choose:',
        es: 'Este artículo está disponible en diferentes variantes. Escoja una:',
        fr: 'Cet article est disponible en plusieurs variantes. Merci de sélectionner :',
        nl: 'Dit artikel is in verschillende varianten beschikbaar. Maak svp een keuze:',
        it: 'Questo articolo è disponibile in diverse varianti. Per favore selezionane una:',
    },
    pleaseSelect: <ILabel>{
        de: 'Bitte auswählen',
        en: 'Please select',
        es: 'Seleccione',
        fr: 'Sélectionnez',
        nl: 'Selecteer',
        it: 'Seleziona',
    },
}